import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

import { MaterialPropType, ThumbnailFilePropType } from 'propTypes/common';

import MatchingCardContent from './MatchingCardContent';

import styles from './styles.module.scss';

const CardDraggable = ({ audio, id, image, text, video }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		isDragging
	} = useDraggable({
		id
	});

	return (
		<div
			{...listeners}
			{...attributes}
			ref={setNodeRef}
			className={cx(styles.MatchingWrapCard, styles.MatchingCard_type_drag)}
			style={{
				transform: CSS.Translate.toString(transform),
				zIndex: isDragging ? 2 : 0
			}}
		>
			<MatchingCardContent
				{...{
					audio,
					image,
					text,
					video,
					id
				}}
				typeCard="drag"
			/>
		</div>
	);
};

CardDraggable.propTypes = {
	audio: MaterialPropType,
	id: PropTypes.string,
	image: ThumbnailFilePropType,
	text: PropTypes.string,
	video: MaterialPropType
};

export default CardDraggable;
